export default __webpack_public_path__ + "static/media/treasure-logo.bdf1838f.svg";